module.exports = __webpack_public_path__ + "static/media/1017051.2e710313.png";